module.exports = __webpack_public_path__ + "img/69.b98cd4ca.jpg";